import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  Suspense,
  lazy,
} from "react";
import "../../css/domainOverview.scss";
import axios from "axios";
import {
  DOMAINOVERVIEW_GET,
  get_backlink_data,
  post_backlink_data,
} from "../../../services/constants";
import { DottLoader } from "../../share/loader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMonthName, monthNameArr } from "../../share/upDater/constant";
import {
  domainRegex,
  formatNumberWithSymbols,
  handleInvitedUserAccess,
  removeUndefinedAndNaN,
} from "../../../helperJs/helper";
import { FiDownload } from "react-icons/fi";
import CountryBasedOnLanuage from "../../share/components/CountryBasedOnLanuage";
import { ZustandStore } from "../../../store/zustand-store";
import Spinner from "../../share/components/spinner";
import html2canvas from "html2canvas";
import RanksProLogo from "../../../Mycomponent/Assets/site-audit/RanksProLogo.png";
import { handleSaveHistory } from ".././Search-History/searchOperations";
import LastCheck from ".././Search-History/LastCheck";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { getCurrentYear } from "../../share/helper-js/current-year";
import LoadingButton from "../../share/components/LoadingButton";
import RefreshDataButton from "../../share/components/RefreshDataButton";
import useDebouncedFunction from "../../../helperJs/debounce";

import globeImg from "../../Assets/rank-tracking-assets/www.svg";
import Tooltip from "../../share/components/tooltip";
import SiteOverviewTable from "../../share/tables/siteOverviewTable.jsx";
import FallbackLoader from "../../share/components/FallbackLoader.jsx";
import { useTranslation } from "react-i18next";
import ChartWrapper from "../../share/d3-charts/ChartWrapper.jsx";
import { chartType } from "../../share/d3-charts/helper.js";
import GroupedBarsChart from "../../share/d3-charts/GroupedBarsChart.jsx";

import Input from "@semcore/ui/input";
import ArrowRightM from "@semcore/ui/icon/ArrowRight/m";
import RecentM from "@semcore/ui/icon/Recent/m";
import DropdownMenu from "../../../common/components/dropdown.jsx";
import SemButton from "../../../common/components/Button.jsx";

const SEOKeyword = lazy(() =>
  import("../../share/components/seo-keyword.component")
);
const WorldWideOverview = lazy(() => import("./WorldWideOverview.jsx"));

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 20,
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 80, // Set vertical padding to 30 pixels
    borderStyle: "solid",
  },
  header: {
    paddingBottom: 20,
  },
  footer: {
    fontSize: 12,
    textAlign: "center",
    color: "grey",
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
  },
  logo: {
    width: 250,
    objectFit: "contain",
    maxHeight: 100,
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    marginBottom: 20,
  },

  tableContainer: {
    marginBottom: 20,
  },

  keywordLoc: {
    flex: 1, // Each cell should take equal space within the row
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
    justifyContent: "start",
    minHeight: 40,
    height: "100%",
    alignItems: "start",
    flexDirection: "column",
  },

  fixedWidthCell: {
    maxWidth: 80, // Disable flex for fixed width cells
  },
  cardContainer: {
    flexDirection: "row",
    flexWrap: "wrap", // Enable flex wrapping
    justifyContent: "space-between", // Arrange cards with equal spacing
    marginTop: 10,
  },
  card: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: 180,
    backgroundColor: "#FFFFFF",
    padding: 10,
    borderRadius: 5,
    marginBottom: 20,
  },
  image: {
    width: 30,
    height: 40,
  },
  title: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#6c757d",
  },
  description: {
    fontSize: 16,
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrowIcon: {
    width: 20,
    height: 20,
    objectFit: "contain",
  },
  view_button: {
    borderWidth: 1,
    borderColor: "#365486",
    padding: 5,
    borderRadius: 7,
    color: "#365486",
    fontSize: 11,
  },
  keyword_bold: {
    fontSize: 13,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  keyword: {
    fontSize: 11,
    color: "#6c757d",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rank: {
    fontSize: 11,
    color: "#6c757d",
    textAlign: "center",
    marginRight: 10,
  },

  pageNumber: {
    position: "absolute",
    fontSize: 11,
    bottom: 45,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  link_text: {
    fontSize: 7,
    textDecoration: "none",
    textOverflow: "hidden",
    textAlign: "start",
  },
  logoHead: {
    width: 125,
    objectFit: "contain",
    maxHeight: 80,
  },
});

export const PdfFile = ({ pdfNewData }) => {
  const DashImage = sessionStorage.getItem("dashboardImage");
  const { t } = useTranslation();
  const Data = JSON.parse(sessionStorage.getItem("pdfSessionData"));
  const Web_url = Data.domainName;
  const image_logo = pdfNewData?.logo?.src || RanksProLogo;

  if (!DashImage) return;

  return (
    <Document>
      <Page size={"A4"} style={styles.page}>
        <View
          style={{
            alignItems: "center",
            display: "flex",
            height: "82vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image style={styles.logo} src={image_logo} />
          <Text style={{ marginBottom: 20 }}>
            {t("competitive_research.title")}
          </Text>
          <Text style={styles.title}>
            {t("dashboard.google_data_chart.with_analytic_login.domain")}{" "}
            {Web_url}
          </Text>
        </View>
      </Page>
      <Page size={"A4"} style={styles.page}>
        <View
          style={{
            ...styles.header,
            alignItems: pdfNewData?.reset
              ? "flex-start"
              : pdfNewData?.logo.position,
          }}
          fixed
        >
          <Image style={styles.logoHead} src={image_logo} />
        </View>

        <View style={{ ...styles.tableContainer }}>
          <View>
            <Image src={DashImage} />
          </View>
        </View>

        {pdfNewData?.footer && (
          <Text style={styles.footer} fixed>
            {pdfNewData?.footer}
          </Text>
        )}
      </Page>
    </Document>
  );
};

const SiteOverview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  const {
    userAccessData,
    country_Language_Data,
    site_overview_page_data,
    site_overview_backlink_data,
    site_overview_worldwide,
    worldwide_domain,
    sel_worldwide_country,
    plan_loaded,
  } = ZustandStore((state) => state);

  const queryParams = new URLSearchParams(location.search);
  const email = localStorage.getItem("admin_mail");
  const domainviewlimit = useSelector((state) => state.domainviewlimit);
  const page_data = userAccessData?.[0]?.access;
  const isPageAccess = handleInvitedUserAccess("siteoverview", page_data);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [domainName, setDomainName] = useState("");
  const [Domain, setDomain] = useState({
    type: "Domain",
    show: "",
  });
  const [domainLocation, setDomainLocation] = useState({
    location_name: "worldwide",
    location_code: "worldwide",
    location_flag: globeImg,
    language_code: "",
    language_name: "",
    show: "worldwide",
  });
  const [pdfLoader, setPdfLoader] = useState(false);
  const [valAlert, setValAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [domainviewData, setDomainViewDate] = useState([]);

  const getDomainViewLmt = async () => {
    try {
      const res = await axios.get(
        `https://app.rankspro.io/api/user/domainviewlmtget/?email=${encodeURIComponent(
          email
        )}`
      );
      return res.data;
    } catch (error) {
      return [];
    }
  };

  const countryLanguageList = useMemo(() => {
    const worldWide = {
      title: t("competitive_research.worldwide"),
      location_code: "Worldwide",
      location_name: "Worldwide",
      location_code_parent: null,
      country_iso_code: "ww",
      location_type: "Country",
      available_languages: [],
      flag: globeImg,
      available_sources: ["google"],
      language_name: "",
      language_code: "",
      keywords: 0,
      serps: 0,
    };
    return {
      ...country_Language_Data,
      data: [worldWide, ...(country_Language_Data?.data || [])],
    };
  }, [country_Language_Data, t]);

  const months = monthNameArr;

  const handleUserBacklinkPostData = (config) => {
    axios
      .post(post_backlink_data(config))
      .then((response) => {
        if (response?.data?.length === 0) {
          ZustandStore.setState({
            site_overview_backlink_data: [],
          });
        } else {
          ZustandStore.setState({
            site_overview_backlink_data: response.data[0],
          });
        }
      })
      .catch(() => {
        ZustandStore.setState({
          site_overview_backlink_data: [],
        });
      });
  };

  const handleUserBacklinkData = async (config, type) => {
    if (type === "post") {
      handleUserBacklinkPostData(config);
      return;
    }
    axios.get(get_backlink_data(config)).then((response) => {
      if (response.data?.length > 0) {
        const data = response.data?.[response?.data?.length - 1];
        ZustandStore.setState({
          site_overview_backlink_data: data,
        });
      } else {
        handleUserBacklinkPostData(config);
      }
    });
  };

  function isDomain(str) {
    const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]+)$/i;
    const isUrl = urlPattern.test(str) ? "Exact URL" : "Domain";
    return isUrl;
  }

  const chart_data = useMemo(() => {
    if (domainviewData?.metrics?.length > 0) {
      const etvArray = [];
      const etvLabel = [];
      const etvAll = [];
      const P1to3 = [];
      const P4to10 = [];
      const P11to50 = [];
      const P51to100 = [];
      domainviewData?.metrics &&
        domainviewData?.metrics?.map((res) => {
          etvLabel.push(months[res.month - 1] + " " + res.year);
          etvArray.push(res.metrics.organic?.etv);
          etvAll.push(res.metrics.paid?.etv);

          P1to3.push(res.metrics.organic?.pos_1 + res.metrics.organic?.pos_2_3);
          P4to10.push(res.metrics.organic?.pos_4_10);
          P11to50.push(
            res.metrics.organic?.pos_11_20 +
              res.metrics.organic?.pos_21_30 +
              res.metrics.organic?.pos_31_40 +
              res.metrics.organic?.pos_41_50
          );
          P51to100.push(
            res.metrics.organic?.pos_51_60 +
              res.metrics.organic?.pos_61_70 +
              res.metrics.organic?.pos_71_80 +
              res.metrics.organic?.pos_81_90 +
              res.metrics.organic?.pos_91_100
          );
        });

      const etv = removeUndefinedAndNaN(etvArray);
      const checkPos1to3 = removeUndefinedAndNaN(P1to3);
      const checkPos4to10 = removeUndefinedAndNaN(P4to10);
      const checkPos11to50 = removeUndefinedAndNaN(P11to50);
      const checkPos51to100 = removeUndefinedAndNaN(P51to100);
      const checkEtvAllData = removeUndefinedAndNaN(etvAll);

      const seoKey =
        checkPos1to3?.length === 0 &&
        checkPos4to10?.length === 0 &&
        checkPos11to50?.length === 0 &&
        checkPos51to100?.length === 0;

      return {
        isSeoKey: seoKey,
        isTraffic: checkEtvAllData?.length === 0,
        etv: etv?.reverse(),
        etvLabel: etvLabel?.reverse(),
        etvAllData: checkEtvAllData?.reverse(),
        pos1to3: checkPos1to3?.reverse(),
        pos4to10: checkPos4to10?.reverse(),
        pos11to50: checkPos11to50?.reverse(),
        pos51to100: checkPos51to100?.reverse(),
      };
    } else {
      return {
        isSeoKey: true,
        isTraffic: true,
        etv: [
          4528.766577849165, 5154.376240376383, 6988.690895890817,
          3897.8004778176546, 804.2746187802404, 769.2224301937968,
          1020.9961916580796,
        ],
        etvLabel: [
          "Jul 2024",
          "Jun 2024",
          "May 2024",
          "Apr 2024",
          "Mar 2024",
          "Feb 2024",
          "Jan 2024",
        ],
        etvAllData: [0, 0, 0, 0, 0, 0, 0],
        pos1to3: [3, 3, 2, 3, 4, 3, 3],
        pos4to10: [7, 7, 9, 3, 9, 10, 7],
        pos11to50: [423, 530, 474, 410, 345, 335, 366],
        pos51to100: [670, 816, 933, 892, 860, 888, 838],
      };
    }
  }, [domainviewData]);

  const chart4_data = useMemo(() => {
    if (domainviewData?.metrics?.length > 0) {
      const data = domainviewData?.metrics;
      const check = data.map((res) => res.metrics.organic?.etv);
      if (removeUndefinedAndNaN(check)?.length === 0) return [];
      const labels = data.map((res) => months[res.month - 1] + " " + res.year);
      const positionData = {
        organic: data.map((res) => res.metrics.organic?.etv),
        paid: data.map((res) => res.metrics.paid?.etv),
      };
      return {
        labels: labels.reverse(),
        datasets: chartType.chart4.label?.map((label) => ({
          label: t(label.name),
          data: positionData[label.key]?.reverse() || [], // dynamically pick dataset
          backgroundColor: label.color,
          borderWidth: 0,
          borderRadius: 1,
          barPercentage: 1,
          categoryPercentage: 0.1,
          barThickness: 12,
        })),
      };
    } else {
      return [];
    }
  }, [domainviewData]);

  const chart2_data = useMemo(() => {
    if (domainviewData?.metrics?.length > 0) {
      const data = domainviewData?.metrics;
      const check = data.map(
        (res) => res.metrics.organic?.pos_1 + res.metrics.organic?.pos_2_3
      );
      if (removeUndefinedAndNaN(check)?.length === 0) return [];
      const labels = data.map((res) => `${months[res.month - 1]} ${res.year}`);
      const positionData = {
        p1to3: data.map(
          (res) => res.metrics.organic?.pos_1 + res.metrics.organic?.pos_2_3
        ),
        p4to10: data.map((res) => res.metrics.organic?.pos_4_10),
        p11to50: data.map(
          (res) =>
            res.metrics.organic?.pos_11_20 +
            res.metrics.organic?.pos_21_30 +
            res.metrics.organic?.pos_31_40 +
            res.metrics.organic?.pos_41_50
        ),
        p51to100: data.map(
          (res) =>
            res.metrics.organic?.pos_51_60 +
            res.metrics.organic?.pos_61_70 +
            res.metrics.organic?.pos_71_80 +
            res.metrics.organic?.pos_81_90 +
            res.metrics.organic?.pos_91_100
        ),
      };
      return {
        labels: labels.reverse(),
        datasets: chartType.chart2.label?.map((label) => ({
          label: t(label.name),
          data: positionData[label.key].reverse() || [], // dynamically pick dataset
          backgroundColor: label.color,
        })),
      };
    } else {
      return [];
    }
  }, [domainviewData, chartType.chart2]);

  const handleSiteOverviewDataUpdate = (data) => {
    if (data?.type === "worldwide") {
      ZustandStore.setState({
        site_overview_worldwide: {
          domain: domainName,
          data: data.metrics,
        },
      });
    }
    setDomainViewDate(data);
    dispatch({ type: "SEOKEYWORD", payload: data });
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  useEffect(() => {
    if (worldwide_domain != null) {
      setDomainName(worldwide_domain);
      const domainType = isDomain(worldwide_domain);
      setDomain((pre) => ({
        ...pre,
        type: domainType,
      }));
      addQueryParamToURL(worldwide_domain);
      handleSiteOverviewData("get", worldwide_domain);
    }
  }, [worldwide_domain]);

  const isSearchCall = sessionStorage.getItem("ISSEARCHTRUE");
  useEffect(() => {
    sessionStorage.setItem("FREE_TRIAL_TABLE", "overviewTable");
    const siteDomainName = sessionStorage.getItem("lastdomainname");
    const country = JSON.parse(sessionStorage.getItem("domainCountry"));
    if (!isPageAccess) {
      sessionStorage.removeItem("lastdomainname");
      sessionStorage.removeItem("domainCountry");
      setDomainName("");
      setDomainLocation({
        location_name: "worldwide",
        location_code: "worldwide",
        location_flag: globeImg,
        language_code: "",
        language_name: "",
        show: "worldwide",
      });
      return;
    }

    if (country) {
      setDomainLocation({
        location_name: country?.location_name,
        location_code: country?.location_code,
        location_flag: country?.location_flag,
        language_code: country?.language_code,
        language_name: country?.language_name,
        show: country?.show,
      });
    }
    if (siteDomainName && !dataLoaded && plan_loaded) {
      setDomainName(siteDomainName);
      const domainType = isDomain(siteDomainName);
      setDomain({
        type: domainType,
        show: domainType,
      });
      setLoading(true);
      addQueryParamToURL(siteDomainName);
      if (
        site_overview_backlink_data?.length === 0 &&
        site_overview_page_data?.length === 0
      ) {
        handleSiteOverviewData("get", siteDomainName);
      } else {
        setValAlert(false);
        handleSiteOverviewDataUpdate(site_overview_page_data);
      }
    }
  }, [isPageAccess, plan_loaded, isSearchCall]);

  const debounceDomainFunction = useDebouncedFunction((target) => {
    // Empty string is not a valid URL
    const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]+)$/i;
    const isUrl = urlPattern.test(target) ? "Exact URL" : "Domain";
    if (Domain.type === isUrl) return;
    setDomain((pre) => ({
      ...pre,
      type: isUrl,
    }));
  }, 1000);

  const keywordChangeHandler = (value) => {
    setValAlert(false);
    sessionStorage.removeItem("lastdomainname");
    setDomainName(value);
    debounceDomainFunction(value);
  };

  const handleDomainPostDataFlow = (config) => {
    const today = new Date();
    var dd = today.getDate();
    var monthNames = monthNameArr;
    var yyyy = today.getFullYear();
    if (dd < 10) dd = "0" + dd;
    let aobj = {
      type:
        domainLocation?.location_name === "worldwide"
          ? "worldwide"
          : "location",
      backlink: [],
      keyword: [],
      metrics: [],
      Month: monthNames[today.getMonth() + 1],
      Year: yyyy,
      last_updated: dd,
    };

    const keywordPromise = axios.get(
      `https://app.rankspro.io/api/user/domainkeyword/?domain_name=${config.domainName}&location_code=${config?.location_code}&language_code=en&location_name=${config.domainCountry}&language_name=${config.domainLanuage}`
    );
    const metricsPromise = axios.get(
      `https://app.rankspro.io/api/user/domainoverview/?domain_name=${config.domainName}&location_code=${config?.location_code}&language_code=en&location_name=${config.domainCountry}&language_name=${config.domainLanuage}`
    );

    Promise.all([keywordPromise, metricsPromise]).then((data) => {
      const first = data[0];
      const second = data[1];
      aobj.keyword = first.data;
      aobj.metrics = second.data;

      if (first.data?.organic?.length === 0) {
        setDomainViewDate([]);
        ZustandStore.setState({
          site_overview_page_data: [],
          site_overview_backlink_data: [],
          worldwide_domain: null,
        });

        setValAlert(
          Domain.type === "Domain"
            ? t("competitive_research.alert_msg.no_enough_data_for_domain")
            : t("competitive_research.alert_msg.no_enough_data_for_page")
        );
        setLoading(false);
      } else {
        setValAlert("");
        ZustandStore.setState({
          site_overview_page_data: aobj,
          worldwide_domain: null,
        });
        handleSiteOverviewDataUpdate(aobj);
      }
    });
  };

  const handleSiteOverviewData = async (type, sessionDomainName) => {
    if (!sessionDomainName || sessionDomainName === "") {
      setValAlert(t("competitive_research.alert_msg.enter_domain"));
      return;
    }

    const domainviewlmtget = await getDomainViewLmt();

    if (
      domainviewlmtget[0]?.limit >= domainviewlimit &&
      domainviewlmtget.length !== 0
    ) {
      setValAlert(t("competitive_research.alert_msg.increase_limit"));
      setDomainViewDate([]);
      ZustandStore.setState({
        site_overview_page_data: [],
        site_overview_backlink_data: [],
        worldwide_domain: null,
      });
    } else {
      setLoading(true);
      setDataLoaded(true);
      setValAlert(false);
      const config = {
        email: email,
        domain: sessionDomainName,
        include_subdomains: true,
      };
      handleUserBacklinkData(config, type);
      sessionStorage.setItem("lastdomainname", sessionDomainName);
      sessionStorage.removeItem("ISSEARCHTRUE");
      const country = JSON.parse(sessionStorage.getItem("domainCountry"));

      const domainviewlimitHandler = () => {
        addQueryParamToURL(sessionDomainName);
        if (domainviewlmtget.length === 0) {
          const json_domainviewlmt = {
            email: email,
            domainoverviewlmt: 1,
          };
          axios
            .post(
              `https://app.rankspro.io/api/user/domainviewlmt/`,
              json_domainviewlmt
            )
            .catch((error) => console.log("limit post failed", error));
        } else {
          const json_updatedomainviewlmt = {
            email: email,
            domainoverviewlmt: domainviewlmtget[0].limit + 1,
          };
          axios
            .put(
              `https://app.rankspro.io/api/user/domainviewlmtupdate/${domainviewlmtget[0].id}/`,
              json_updatedomainviewlmt
            )
            .catch((error) => console.log("limit update failed", error));
        }
      };

      const json_getDomain = {
        domainName: sessionDomainName,
        domainCountry: country
          ? country?.location_name
          : domainLocation?.location_name,
        domainLanuage: country
          ? country?.language_name
          : domainLocation?.language_name,
        location_code: country
          ? country?.location_code
          : domainLocation?.location_code,
      };

      if (type === "post") {
        setLoading(true);
        domainviewlimitHandler();
        handleDomainPostDataFlow(json_getDomain);
        return;
      }

      axios(DOMAINOVERVIEW_GET(json_getDomain)).then((res) => {
        if (res.data.length !== 0) {
          const data = res.data[0];
          domainviewlimitHandler();
          ZustandStore.setState({
            site_overview_page_data: data,
            worldwide_domain: null,
          });
          handleSiteOverviewDataUpdate(data);
        } else {
          domainviewlimitHandler();
          handleDomainPostDataFlow(json_getDomain);
        }
      });
    }
  };

  const fatch_DOMAINOVERVIEW_GET = (e, type) => {
    if (!isPageAccess) return;
    e.preventDefault();
    if (domainName === "") {
      setValAlert(t("competitive_research.alert_msg.enter_domain"));
    } else if (!domainRegex.test(domainName) && Domain.type === "Domain") {
      setValAlert(t("competitive_research.alert_msg.valid_domain"));
    } else {
      const domainType = isDomain(domainName);
      setDomain({
        type: domainType,
        show: domainType,
      });
      setLoading(true);
      sessionStorage.setItem("domainCountry", JSON.stringify(domainLocation));
      const config2 = {
        domain: domainName,
        type: "site",
        location: domainLocation,
      };
      ZustandStore.setState({
        site_overview_page_data: [],
        site_overview_backlink_data: [],
        worldwide_domain: null,
        site_overview_worldwide: {
          domain: "",
          data: [],
        },
        history_data: {
          data: [],
          error: false,
          loading: true,
        },
      });
      sessionStorage.setItem("lastdomainname", domainName);
      handleSaveHistory(config2);
      handleSiteOverviewData(type, domainName);
    }
  };

  const addQueryParamToURL = (name) => {
    const sessionDomainName = sessionStorage.getItem("lastdomainname");
    var domainNameValue = null;
    if (sessionDomainName != null) {
      domainNameValue = sessionDomainName;
    } else {
      domainNameValue = domainName;
    }

    const country = JSON.parse(sessionStorage.getItem("domainCountry"));
    var countryName = null;
    if (country != null) {
      countryName = country?.location_name;
    } else {
      countryName = domainLocation?.location_name;
    }

    if (domainNameValue) {
      queryParams.set("domain", domainNameValue);
      queryParams.set("country", countryName);
      queryParams.set("type", Domain.type || "Domain");
    } else {
      queryParams.delete("domain");
      queryParams.delete("country");
      queryParams.delete("Type");
    }
    const newSearch = queryParams.toString();
    window.history.pushState({}, "", `?${newSearch}`);
  };

  const countryDetailHandler = (e) => {
    setDomainLocation({
      location_name:
        e?.location_name === "Worldwide" ? "worldwide" : e?.location_name,
      location_code:
        e?.location_code === "Worldwide" ? "worldwide" : e?.location_code,
      location_flag: e?.flag,
      language_code: e?.language_code,
      language_name: e?.language_name,
      show: e?.location_name === "Worldwide" ? "worldwide" : "",
    });
  };

  const backlink_histort = useMemo(() => {
    if (site_overview_backlink_data?.length === 0) {
      return {
        history_list: [],
        total_backlinks: 0,
      };
    } else {
      const total_backlinks = site_overview_backlink_data?.total_backlinks
        ? site_overview_backlink_data?.total_backlinks
        : site_overview_backlink_data?.data?.[0]?.total_backlinks;
      const history_list = site_overview_backlink_data?.history_list
        ? site_overview_backlink_data?.history_list
        : site_overview_backlink_data?.data?.[0]?.history_list;
      return {
        history_list: history_list?.slice(-3) || [],
        total_backlinks: total_backlinks,
      };
    }
  }, [site_overview_backlink_data]);

  const handleRoute = () => {
    setPdfLoader(true);
    const element = document.getElementById("overveiw");

    if (element) {
      html2canvas(element, {
        logging: false,
        allowTaint: true,
        useCORS: true, // If your container has external images, this helps to prevent cross-origin issues.
      })
        .then((canvas) => {
          // Convert the canvas to a data URL in JPG format
          const imgData = canvas.toDataURL("image/jpeg");
          // Save the image data to sessionStorage
          sessionStorage.setItem("dashboardImage", imgData);
          sessionStorage.setItem(
            "pdfSessionData",
            JSON.stringify({ domainName: domainName, id: 11 })
          );
          navigate("/CrawledPageEditor");
        })
        .catch((error) => {
          setPdfLoader(false);
          console.error("Error capturing the dashboard as an image:", error);
        });
    }
  };

  const isoDateString =
    domainviewData?.last_updated &&
    domainviewData?.Month &&
    domainviewData?.Year
      ? `${domainviewData.last_updated}-${domainviewData.Month}-${domainviewData.Year}`
      : new Date();

  const handleBacklinkDomain = () => {
    dispatch({ type: "BACKLINKDOMAIN", payload: domainName });
    navigate("/backlinks");
  };

  const handleWorldWideLocatioUpdate = useCallback(
    (e, country) => {
      const location = country
        ? {
            location_name: country?.location_name,
            location_code: country?.location_code,
            location_flag: country?.location_flag,
            language_code: country?.language_code,
            language_name: country?.language_name,
            show: "worldwide",
          }
        : {
            location_name: "worldwide",
            location_code: "worldwide",
            location_flag: globeImg,
            language_code: "",
            language_name: "",
            show: "worldwide",
          };

      country && setLoading(true);
      setDomainLocation(location);
      sessionStorage.setItem("domainCountry", JSON.stringify(location));
    },
    [domainName]
  );

  const showComponent = useMemo(() => {
    if (site_overview_worldwide?.data?.length > 0) {
      return {
        exactUrl: Domain.show === "Exact URL" && Boolean(sel_worldwide_country),
        domain: Domain.show === "Domain" && Boolean(sel_worldwide_country),
      };
    } else {
      return {
        exactUrl: Domain.show === "Exact URL",
        domain: Domain.show === "Domain",
      };
    }
  }, [site_overview_worldwide, Domain, sel_worldwide_country]);

  const DomainArr = useMemo(() => {
    return {
      value: Domain.type || t("competitive_research.placeholders.is_domain"),
      placeholder: "Select Domain Type",
      disabled: false,
      data: ["Domain", "Exact URL"],
      height: "35px",
      loading: false,
    };
  }, [Domain.type, t]);

  const domainHandler = useCallback(
    (category) => {
      if (category === isDomain(domainName)) return;
      if (category == "Domain" && isDomain(domainName) === "Exact URL") {
        const match = domainName.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
        const domain = match ? match[1].replace(/\s/g, "") : "";
        setDomainName(domain);
      } else {
        setDomainName("");
      }
      setDomain((pre) => ({
        ...pre,
        type: category,
      }));
    },
    [domainName]
  );

  return (
    <main className="main-pd overview-container ">
      <div className="w-100">
        <div className="keyword2 rounded-5 pb-0">
          <div className="w-100">
            <h5>{t("competitive_research.title")}</h5>
            <p className="keyword-p">{t("competitive_research.discription")}</p>
            <form
              onSubmit={(e) => {
                fatch_DOMAINOVERVIEW_GET(e, "get");
              }}
            >
              <div className="overview-search-contain d-flex justify-content-between">
                <div className="d-flex align-items-center justify-content-start flex-wrap gap-2">
                  <div className="keyword-input font-regular heading-small">
                    <Input w={"100%"} h={"35px"}>
                      <Input.Value
                        type={"text"}
                        placeholder={t(
                          "competitive_research.placeholders.enter_domain"
                        )}
                        value={domainName}
                        onChange={(value) => {
                          keywordChangeHandler(value);
                        }}
                      />
                    </Input>
                  </div>
                  <div className="dropdon_country_lang">
                    <DropdownMenu
                      {...{
                        menuData: DomainArr,
                        handleSelect: domainHandler,
                      }}
                    />
                  </div>
                  <CountryBasedOnLanuage
                    data={countryLanguageList}
                    img={
                      domainLocation?.show === "Worldwide"
                        ? globeImg
                        : domainLocation?.location_flag
                    }
                    title={
                      domainLocation?.show === "Worldwide" ||
                      domainLocation?.location_name === "worldwide"
                        ? t("competitive_research.placeholders.worldwide")
                        : `${domainLocation?.language_name} / ${domainLocation?.location_name}`
                    }
                    callback={countryDetailHandler}
                  />

                  <SemButton
                    name={t("common_buttons.search")}
                    title={t("common_buttons.search")}
                    disabled={!isPageAccess}
                    onClick={(e) => fatch_DOMAINOVERVIEW_GET(e, "get")}
                    icon={<ArrowRightM />}
                  />

                  <Link to={"/activity?type=site"} className="">
                    <SemButton
                      name={t("common_buttons.activity")}
                      title={t("common_buttons.activity")}
                      icon={<RecentM />}
                    />
                  </Link>

                  <RefreshDataButton
                    date={isoDateString}
                    disable={domainviewData?.length === 0 || loading}
                    handleRefresh={fatch_DOMAINOVERVIEW_GET}
                  />

                  {domainviewData.length !== 0 ? (
                    <div className="d-flex justify-content-between align-item-center">
                      <LoadingButton loading={pdfLoader}>
                        <FiDownload
                          onClick={handleRoute}
                          className="down"
                          title="download SiteOverview PDF"
                        />
                      </LoadingButton>
                    </div>
                  ) : null}
                </div>
              </div>
            </form>
            {isPageAccess ? (
              <>
                {domainviewData.length === 0 ? (
                  <div className="mt-2">
                    <LastCheck type="site" />
                  </div>
                ) : null}

                <p className="heading-medium font-bold vl-msd-line mt-3 ms-1">
                  <span>{valAlert}</span>{" "}
                </p>
              </>
            ) : (
              <p className="heading-medium font-bold vl-msd-line mt-3 ms-1">
                <span>
                  {t("competitive_research.alert_msg.connot_access_module")}
                </span>{" "}
              </p>
            )}
          </div>
        </div>

        <div id="overveiw">
          {site_overview_worldwide?.data?.length > 0 && (
            <Suspense fallback={<DottLoader />}>
              <WorldWideOverview countryChange={handleWorldWideLocatioUpdate} />
            </Suspense>
          )}

          {loading ? (
            <DottLoader />
          ) : domainviewData.length !== 0 ? (
            <>
              {showComponent?.exactUrl ? (
                <>
                  <div className="d-flex align-items-center mb-4">
                    <div
                      className="keyword-card point"
                      onClick={() => handleBacklinkDomain()}
                    >
                      <div className="d-flex keyword-card-header">
                        <h6 className="">
                          {t("backlinks.backlink_analysis.title")}
                          <Tooltip
                            title={t(
                              "backlinks.backlink_analysis.overview.box.backlinks.tooltip"
                            )}
                          />
                        </h6>
                        <h5 className="mb-0">
                          {backlink_histort?.total_backlinks?.toLocaleString() ||
                            0}
                        </h5>
                      </div>
                    </div>
                    <div className="keyword-card ms-2">
                      <div className="d-flex keyword-card-header">
                        <h6 className="">
                          {t("dashboard.keyword_rank_chart.labels.total")}{" "}
                          {t(
                            "site_audit.dashboard_page.box.organic_keyword.title"
                          )}
                        </h6>
                        <h5 className="mb-0">
                          {domainviewData?.keyword?.organic?.length || 0}
                        </h5>
                      </div>
                    </div>
                    <div className="keyword-card ms-2">
                      <div className="d-flex keyword-card-header">
                        <h6>
                          {t("dashboard.keyword_rank_chart.labels.total")}{" "}
                          {t("competitive_research.aio.title")}
                        </h6>
                        <h5 className="mb-0">
                          {domainviewData?.keyword?.ai?.length || 0}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <SiteOverviewTable
                        type={"organic"}
                        title={t(
                          "site_audit.dashboard_page.box.organic_keyword.title"
                        )}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <SiteOverviewTable
                        type={"ai"}
                        title={t("competitive_research.aio.title")}
                      />
                    </div>
                  </div>
                </>
              ) : showComponent?.domain ? (
                <>
                  <div className="row g-3">
                    <div className="col-12 col-lg-4 col-xl-2">
                      {chart_data?.etv?.length !== 0 &&
                      backlink_histort?.history_list?.length > 0 ? (
                        <div className="row g-3">
                          {/* Organic Keywords Card */}
                          <div className="col-md-4 col-lg-12">
                            <div className="cir-card-wth-rank">
                              <h1>
                                {t(
                                  "competitive_research.circle_blocks.total_organic_keywords"
                                )}
                              </h1>
                              <div className="cont-card">
                                {[2, 1, 0].map((index) => (
                                  <React.Fragment key={index}>
                                    <div className="circle">
                                      <span className="cir-mon">
                                        {getMonthName(
                                          domainviewData?.metrics?.[index]
                                            ?.month
                                        )}
                                      </span>
                                      <span className="cir-val">
                                        {formatNumberWithSymbols(
                                          domainviewData?.metrics?.[index]
                                            ?.metrics?.organic?.count
                                        )}
                                      </span>
                                    </div>
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Organic Monthly Traffic Card */}
                          <div className="col-md-4 col-lg-12">
                            <div className="cir-card-wth-rank">
                              <h1>
                                {t(
                                  "competitive_research.circle_blocks.organic_monthly_traffic"
                                )}
                              </h1>
                              <div className="cont-card">
                                {[2, 1, 0].map((index) => (
                                  <React.Fragment key={index}>
                                    <div className="circle">
                                      <span className="cir-mon">
                                        {getMonthName(
                                          domainviewData?.metrics?.[index]
                                            ?.month
                                        )}
                                      </span>
                                      <span className="cir-val">
                                        {formatNumberWithSymbols(
                                          Math.round(
                                            domainviewData?.metrics?.[index]
                                              ?.metrics?.organic?.etv
                                          )
                                        )}
                                      </span>
                                    </div>
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Backlinks Card */}
                          <div className="col-md-4 col-lg-12">
                            <div
                              className="cir-card-wth-rank point"
                              onClick={() => handleBacklinkDomain()}
                            >
                              <h1>
                                {t(
                                  "competitive_research.circle_blocks.backlinks"
                                )}
                              </h1>
                              <div className="cont-card">
                                {backlink_histort?.history_list?.map(
                                  (data, index, arr) => (
                                    <React.Fragment key={index}>
                                      <div className="circle">
                                        <span className="cir-mon">
                                          {data?.month?.slice(0, 3)}
                                        </span>
                                        <span className="cir-val">
                                          {formatNumberWithSymbols(
                                            data?.backlinks
                                          )}
                                        </span>
                                      </div>
                                    </React.Fragment>
                                  )
                                )}
                                {backlink_histort?.history_list?.length ===
                                0 ? (
                                  <>
                                    <React.Fragment>
                                      <div className="circle">
                                        <span className="cir-mon">
                                          {getMonthName(
                                            domainviewData?.metrics?.[2]?.month
                                          )}
                                        </span>
                                        <span className="cir-val">0</span>
                                      </div>
                                    </React.Fragment>
                                    <React.Fragment>
                                      <div className="circle">
                                        <span className="cir-mon">
                                          {getMonthName(
                                            domainviewData?.metrics?.[1]?.month
                                          )}
                                        </span>
                                        <span className="cir-val">0</span>
                                      </div>
                                    </React.Fragment>
                                    <React.Fragment>
                                      <div className="circle">
                                        <span className="cir-mon">
                                          {getMonthName(
                                            domainviewData?.metrics?.[0]?.month
                                          )}
                                        </span>
                                        <span className="cir-val">0</span>
                                      </div>
                                    </React.Fragment>
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : chart_data?.etv?.length === 0 ||
                        backlink_histort?.history_list?.length === 0 ? (
                        <div className="h-100">
                          <Spinner />
                        </div>
                      ) : null}
                    </div>
                    <div className="col-12 col-lg-8 col-xl-6 overview">
                      <ChartWrapper
                        chart={chartType.chart4}
                        key={"Total Traffic"}
                      >
                        <GroupedBarsChart data={chart4_data} />
                      </ChartWrapper>
                      <div className="mt-4">
                        <ChartWrapper
                          chart={chartType.chart2}
                          key={"SEO Keywords Distribution"}
                        >
                          <GroupedBarsChart data={chart2_data} />
                        </ChartWrapper>
                      </div>
                    </div>
                    <div className="col-12 col-lg-12 col-xl-4">
                      <div className="mb-2 h-50">
                        <SiteOverviewTable
                          type={"organic"}
                          totalOrganicKeywords={formatNumberWithSymbols(
                            domainviewData?.metrics?.[0]?.metrics?.organic
                              ?.count
                          )}
                          title={t(
                            "site_audit.dashboard_page.box.organic_keyword.title"
                          )}
                        />
                      </div>
                      <SiteOverviewTable
                        type={"ai"}
                        title={t("competitive_research.aio.title")}
                      />
                    </div>
                  </div>
                </>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
    </main>
  );
};

export default SiteOverview;
